export default __webpack_public_path__ + "static/media/bg-pattern-small-circle.f374d13e.svg";